import { taoke_cms_info, taoke_cms_set, taoke_cms_filter_set } from '@/api/cmsWebSite'

export default {
  state: {
    info: {
      ad: '',
      add_time: '',
      cms_agent: '',
      cms_agent_contribution_1: '',
      cms_agent_contribution_2: '',
      cms_agent_return_commission_1: '',
      cms_agent_return_commission_2: '',
      cms_agent_return_commission_3: '',
      cms_agent_return_commission_4: '',
      cms_agent_return_commission_level_1: '',
      cms_agent_return_commission_level_2: '',
      cms_agent_return_commission_level_3: '',
      cms_member: 1,
      cms_member_contribution_1: '',
      cms_member_contribution_2: '',
      cms_member_return_commission_1: '',
      cms_member_return_commission_2: '',
      cms_member_return_commission_3: '',
      cms_member_return_commission_4: '',
      cms_member_return_commission_level_1: '',
      cms_member_return_commission_level_2: '',
      cms_member_return_commission_level_3: '',
      cms_pid: '',
      domain: '',
      filter_commission: '',
      filter_dscr: '',
      filter_open: '',
      filter_salenum: '',
      filter_source: '',
      footer: '',
      icpno: '',
      id: 2,
      jq_qq_code: '',
      logo: '',
      qq: '',
      qq_code: '',
      seo_description: '',
      seo_keyword: '',
      seo_title: '',
      share_domain: '',
      slogan: '',
      ssl: '',
      tbk_member_id: '',
      title: '',
      tj_code: '',
      tkl_pid: '',
      update_time: '',
      wx: '',
      wxgzh: '',
      wxgzh_qrurl: '',
      withdraw_min_amount: '',
      withdraw_base_amount: '',
      cms_commission_level: '',
      cms_commission_settle_delay_days: '',
      plugin_fljqr_ad_text:'',
      plugin_fljqr_title:'',
      // cms_agent_modules_open: '',
      // cms_member_modules_open: '',

      cms_ui_config: null,
    },

    activate: false,  // 是否过期
    isOpen: false,  // 是否开通过cms
  },

  mutations: {
    SET_INFO_DETAIL(state, data) {
      Object.keys(data).forEach((key) => {
        state.info[key] = data[key]
      })
    },

    SET_INFO(state, info) {
      state.info = { ...info }
    },

    SET_ACTIVATE(state, bool) {
      state.activate = bool
    },

    SET_OPEN(state, bool) {
      state.isOpen = bool
    },
  },

  actions: {
    // 获取cms用户信息
    async GetCmsInfo({ commit }) {
      const { data } = await taoke_cms_info()
      // error_code == 1 表示未激活
      if (data.error_code == 0) {
        commit('SET_INFO', data.info)
        commit('SET_ACTIVATE', true)
        commit('SET_OPEN', true)
      }

      return data
    },

    // 设置cms用户信息
    async SetCmsInfo({ dispatch }, params) {
      const { data } = await taoke_cms_set(params)

      if (data.error_code == 0) {
        await dispatch('GetCmsInfo')
      }

      return data
    },

    // 设置cms商品筛选
    async SetCmsFilter({ dispatch }, params) {
      const { data } = await taoke_cms_filter_set(params)
      if (data.error_code == 0) {
        dispatch('GetCmsInfo')
      }

      return data
    },

  },
}


